var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitEuKmh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_eu_x5F_kmh_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_eu_x5F_kmh"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 48,
    cy: 48,
    r: 46
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,14c18.778,0,34,15.222,34,34S66.778,82,48,82S14,66.778,14,48S29.222,14,48,14 M48,4 C23.738,4,4,23.738,4,48s19.738,44,44,44s44-19.738,44-44S72.262,4,48,4L48,4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.382,66h1.547v5.525l2.47-2.821h1.69l-2.353,2.717l2.353,3.835H37.36l-1.664-2.665l-0.767,0.871v1.794h-1.547V66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.038,68.704h1.482v0.806c0.121-0.295,0.325-0.52,0.611-0.676c0.286-0.156,0.65-0.234,1.092-0.234 c0.511,0,0.925,0.087,1.241,0.26c0.316,0.174,0.548,0.426,0.696,0.754c0.138-0.328,0.37-0.58,0.695-0.754 c0.325-0.173,0.726-0.26,1.203-0.26c0.78,0,1.341,0.204,1.684,0.611c0.342,0.407,0.513,0.992,0.513,1.755v4.29h-1.56v-3.939 c0-0.528-0.083-0.888-0.247-1.078c-0.165-0.191-0.455-0.287-0.871-0.287s-0.711,0.092-0.884,0.273s-0.264,0.516-0.273,1.002v4.029 h-1.56v-3.939c0-0.528-0.083-0.888-0.247-1.078c-0.165-0.191-0.455-0.287-0.871-0.287s-0.711,0.092-0.884,0.273 s-0.264,0.516-0.273,1.002v4.029h-1.547V68.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.754,66h1.209l-4.291,9.256h-1.209L54.754,66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.301,66h1.548v3.354c0.276-0.502,0.823-0.754,1.638-0.754c0.78,0,1.341,0.204,1.684,0.611 c0.342,0.407,0.514,0.992,0.514,1.755v4.29h-1.561v-3.939c0-0.528-0.082-0.888-0.247-1.078c-0.164-0.191-0.455-0.287-0.871-0.287 c-0.425,0-0.724,0.096-0.896,0.287c-0.174,0.19-0.26,0.55-0.26,1.078v3.939h-1.548V66z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitEuKmh);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_eu_kmh.f19a34ce67145086836ea10c3d65e927.svg";
export { ForwardRef as ReactComponent };